module.exports = __webpack_public_path__ + "img/science.f6dfb8e4.png";